import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box } from '@mui/material'
import { ArrowForwardOutlined, SaveOutlined } from '@mui/icons-material'
import { SidebarNavigationItem } from '@/features/sidebar'

interface SidebarNavigationSectionProps {
  readonly isCollapsed?: boolean
}

export const SidebarNavigationSection: FC<SidebarNavigationSectionProps> = ({
  isCollapsed = false,
}) => {
  return (
    <Box sx={containerSx(isCollapsed)}>
      <SidebarNavigationItem
        icon={<ArrowForwardOutlined />}
        label="Events"
        route="/hosts"
        isCollapsed={isCollapsed}
        matchExact
      />
      <SidebarNavigationItem
        icon={<SaveOutlined />}
        label="Drafts"
        route="/drafts"
        isCollapsed={isCollapsed}
      />
    </Box>
  )
}

const containerSx = (isCollapsed: boolean): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: isCollapsed ? 'center' : 'stretch',
  gap: 1.5,
})
